'use strict';exports.__esModule = true;var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _checkAdvancedFiltersQuantity = require('./checkAdvancedFiltersQuantity');var _checkAdvancedFiltersQuantity2 = _interopRequireDefault(_checkAdvancedFiltersQuantity);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var checkFiltersQuantity = function checkFiltersQuantity(values, routeData) {
  var advancedFilters = values.advancedFilters && Object.keys(values.advancedFilters).length ?
  values.advancedFilters :
  routeData.params;

  var commodities = advancedFilters.commodities;
  var filteredCommodities = values.optionType === 'buy' && commodities ?
  commodities.filter(function (item) {return item !== 'roommates';}) :
  commodities;

  if (filteredCommodities) {
    advancedFilters.commodities = filteredCommodities;
  }

  var advanced = (0, _checkAdvancedFiltersQuantity2.default)(advancedFilters);
  var existedPrice = values.minPrice || values.maxPrice;
  var primary = Object.keys(_constants.initialFieldsValuesForMobileFilters).
  filter(function (elem) {return elem !== 'minPrice' && elem !== 'maxPrice';}).
  reduce(function (acc, item) {
    var currentValue = values[item];
    var initialValue = _constants.initialFieldsValuesForMobileFilters[item];
    if (!!currentValue && !(0, _isEqual2.default)(currentValue, initialValue)) {
      acc += 1;
    }
    return acc;
  }, 0);
  var price = existedPrice ? 1 : 0;
  return +advanced + primary + price;
};exports.default =

checkFiltersQuantity;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/checkFiltersQuantity.js
// module id = 1251
// module chunks = 0